'use strict';

exports.reset = function (css) {
  var style = document.createElement('style');

  style.type = 'text/css';

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  (document.head || document.getElementsByTagName('head')[0]).appendChild(style);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-react/dist/npm/es5/libs/utils/style.js
// module id = 1816
// module chunks = 0